import React from "react";
import { fmtDate } from "@/lib/constants";
import { useLang } from "@/i18n";

// Gelijktijdige plaatsen, nog niet afgerekende verkopen en openstaande facturen van dezelfde gast.
export default function SettlementExtras({ extras, incl = [], onToggle }) {
  const { t } = useLang();
  if (!extras) return null;
  const same = (extras.parallel || []).filter((p) => p.same_end);
  const diff = (extras.parallel || []).filter((p) => !p.same_end);
  const sales = extras.sales || [];
  if (!same.length && !diff.length && !sales.length) return null;

  return (
    <div className="space-y-2" data-testid="settlement-extras">
      {same.length > 0 && (
        <p className="text-xs text-muted-foreground" data-testid="settle-merged">
          {t("settle_merged")}: <span className="font-semibold text-foreground">{same.map((p) => p.pitch_label).join(", ")}</span>
        </p>
      )}
      {diff.map((p) => (
        <label key={p.reservation_id} className="flex items-start gap-2 rounded-lg border border-amber-300 bg-amber-50 px-3 py-2 text-xs text-amber-900"
          data-testid={`settle-parallel-${p.pitch_label}`}>
          <input type="checkbox" className="mt-0.5" checked={incl.includes(p.reservation_id)}
            onChange={() => onToggle(p.reservation_id)} data-testid={`settle-include-${p.pitch_label}`} />
          <span>
            <span className="font-semibold">{t("settle_parallel_warn")} {p.pitch_label}</span>{" "}
            ({fmtDate(p.arrival)} → {fmtDate(p.departure)}). {t("settle_parallel_ask")}
          </span>
        </label>
      ))}
      {sales.length > 0 && (
        <p className="text-xs text-muted-foreground" data-testid="settle-sales">
          {t("settle_sales_added")}: {sales.map((s) => s.number).join(", ")}
        </p>
      )}
    </div>
  );
}
